import { useState } from 'react';
import { useLang } from '../lib/lang';
import { googleConfig } from '../lib/api';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

// Self-managed Google OAuth (Authorization Code flow) using the site owner's
// own Client ID. Redirects to Google, comes back to /auth/google?code=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuthButton({ label }) {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    setBusy(true);
    try {
      const { data } = await googleConfig();
      if (!data.enabled || !data.client_id || !data.redirect_uri) { toast.info(t('googleComingSoon')); setBusy(false); return; }
      const params = new URLSearchParams({
        client_id: data.client_id,
        redirect_uri: data.redirect_uri,
        response_type: 'code',
        scope: 'openid email profile',
        access_type: 'online',
        prompt: 'select_account',
      });
      window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
    } catch (e) {
      toast.error('Erreur Google. Réessayez.');
      setBusy(false);
    }
  };

  return (
    <button type="button" onClick={handleClick} disabled={busy} data-testid="google-auth-button"
      className="w-full flex items-center justify-center gap-3 rounded-xl border-2 border-border bg-white text-rolex-green font-semibold text-sm h-12 hover:bg-cream/60 hover:border-rolex-green/30 transition-colors">
      {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : (
        <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
          <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
        </svg>
      )}
      {label || t('googleContinue')}
    </button>
  );
}
